
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("/var/tmp/cleverdocs-unified.20261102T223618Z-1822436/frontend/sentry.client.config.ts")
            }
          });